import axios from 'axios';

var instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
    timeout: 1000 * 12
});

instance.interceptors.request.use(
    config => {
        config.headers['Authorization'] = 'H5.eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5MjI3Y2I4Ni0wNTUyLTRhZDQtYTAxZS0wMTIyNDBlMjhjMTQiLCJDUkVBVEVEIjoxNjU3NTIzNzc4MDU2LCJleHAiOjE2NTg5OTUwMDZ9.IDx3KvnmzuX3tc3lhAdKkDq4P8_8QSPDQyfRKdQE1hGCX5auuFTRRsPlMZXen8bUc64qG5c6J-XrjdD5dIvDZw.H5'
        return config;
    },
    error => Promise.error(error)
)

instance.interceptors.response.use(
    response => {
        const res = response.data

        if (res.code != 1000) {
            return Promise.reject(response.data);
        }
        return Promise.resolve(res.data)
    },
    error => {
        const { response } = error;
        return Promise.resolve(response.data);
    }
)

export default instance